// 判断当前是否为 wi5.pw 站点（含 www 前缀）
export const isWi5Domain = () => {
    const host = window.location.hostname;
    return host === 'wi5.pw' || host === 'www.wi5.pw';
};
